import { render, staticRenderFns } from "./UserSendAsPermissionRequestModal.html?vue&type=template&id=60c48096&scoped=true&external"
import script from "./UserSendAsPermissionRequestModal.js?vue&type=script&lang=js&external"
export * from "./UserSendAsPermissionRequestModal.js?vue&type=script&lang=js&external"
import style0 from "./UserSendAsPermissionRequestModal.scss?vue&type=style&index=0&id=60c48096&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c48096",
  null
  
)

export default component.exports